import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './css/reset.css';
import './css/style.css';
import './css/xeicon/xeicon.min.css';


import reportWebVitals from './reportWebVitals';
import { StoreProvider } from './contexts/Store';
import { LangProvider } from 'contexts/LangContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <LangProvider>
      <StoreProvider>
        <App />
      </StoreProvider>
    </LangProvider>
);

reportWebVitals();
